const cachedRootValue = new Map();

const CACHED_ROOT_VALUE_KEY = 'CACHED_ROOT_VALUE_KEY';
const DEFAULT_PX_VALUE = 16;

const getRootValue = () => {
  if (cachedRootValue.has(CACHED_ROOT_VALUE_KEY)) {
    return cachedRootValue.get(CACHED_ROOT_VALUE_KEY);
  }

  if (typeof window === 'undefined') {
    return DEFAULT_PX_VALUE;
  }

  const rootValue = Number.parseFloat(window.getComputedStyle(document.documentElement).fontSize);

  cachedRootValue.set(CACHED_ROOT_VALUE_KEY, rootValue);

  return rootValue;
};

const pxToRem = (px: number, remValue?: number) => {
  return `${px / (remValue ? remValue : getRootValue())}rem`;
};

export { pxToRem };
